__turbopack_context__.v({
  "filter-header": "filter-header-module-scss-module__2DDkja__filter-header",
  "filter-header__close-button": "filter-header-module-scss-module__2DDkja__filter-header__close-button",
  "filter-header__text": "filter-header-module-scss-module__2DDkja__filter-header__text",
});
